import request from '@/utils/request'

export const getWaterVoucherConfigList = (params?: { storeId?: number }) =>
  request({
    url: '/waterVoucher/config/list',
    method: 'get',
    params
  })

export const addWaterVoucherConfig = (data: any) =>
  request({
    url: '/waterVoucher/config',
    method: 'post',
    data
  })

export const updateWaterVoucherConfig = (data: any) =>
  request({
    url: '/waterVoucher/config',
    method: 'put',
    data
  })

export const deleteWaterVoucherConfig = (id: number) =>
  request({
    url: `/waterVoucher/config/${id}`,
    method: 'delete'
  })

export const setWaterVoucherConfigEnabled = (id: number, enabled: number) =>
  request({
    url: `/waterVoucher/config/${id}/enabled`,
    method: 'put',
    params: { enabled }
  })

/** 直接设置套餐排序值（越小越靠前） */
export const waterVoucherConfigSetSort = (params: { id: number | string; sort: number }) =>
  request({
    url: `/waterVoucher/config/sort`,
    method: 'post',
    params: { id: params.id, sort: params.sort }
  })
